import React from 'react'
import Game from 'modules/Game'
import Eq from 'modules/Eq'
import * as gameTypes from 'constants/gameTypes'

const GameEqPeak = () => {
  return (
    <Game gameType={gameTypes.EQ_CUT}>
      {({ next }) => (
        <Eq
          next={next}
          filterType={'peaking'}
          key={'eq_cut'}
          gameType={gameTypes.EQ_CUT}
        />
      )}
    </Game>
  )
}

export default GameEqPeak
